import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Saves element scroll position and restores it on controller connect.
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Values
 * -------
 *
 * identifier - (required) - identifier to save scroll position (will be used as window property)
 *
 * Usage
 * -------
 *
 * <div
 *   data-controller="scroll-save"
 *   data-scroll-save-identifier-value="identifier"
 *   data-action="scroll->scroll-save#save"
 * >
 * </div>
 */
export default class default_1 extends Controller {
    static values = { identifier: String };
    connect() {
        const scrollLeft = localStorage.getItem(this.identifierValue);
        if (scrollLeft) {
            this.element.scrollLeft = parseInt(scrollLeft);
        }
    }
    save() {
        localStorage.setItem(this.identifierValue, this.element.scrollLeft.toString());
    }
}
